import supportApis from "../../api/support";

const state = {
    supports: {
      data: [{
        id: 12345,
        tracking_number: 'BA123123',
        created_At: '03/04/2021',
        desc: 'Giao Lấy Hàng'
      }]
    },
};

const getters = {};

const mutations = {
    SET_supports: (state, payload) => state.supports = payload,
};

const actions = {
    async createsupport({commit}, data) {
      await supportApis.createsupport(data);
    },
    async getsupports({commit}, payload) {
      try {
        const {data} = await supportApis.getsupports(payload);
        await commit("SET_supports", data);
      } catch (err) {

      }
    }
};

export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};